import { damageControlApi, reportDamageControlFailure } from "@/api/damageControl";
import damageControlAccessMixin from "@/mixins/damageControlAccessMixin";
import roleMixin from "@/mixins/roleMixin";

// Both entry points load once per booking/access context; late replies must not
// restore another booking's data or data from a branch whose access was revoked.
export default {
  mixins: [roleMixin, damageControlAccessMixin],
  data: () => ({ act: null, loading: false, errorText: "", loadSequence: 0, disposed: false }),
  computed: {
    enabled() { return this.damageControlAvailable; },
    contextKey() { return JSON.stringify([this.damageControlCompany && this.damageControlCompany.id, this.bookingId, this.enabled]); },
  },
  watch: {
    contextKey: { immediate: true, handler() { this.loadAct(); } },
  },
  beforeDestroy() { this.disposed = true; this.loadSequence += 1; },
  methods: {
    async loadAct() {
      const sequence = ++this.loadSequence;
      const context = this.contextKey;
      const active = () => !this.disposed && this.enabled && sequence === this.loadSequence && context === this.contextKey;
      this.act = null;
      this.errorText = "";
      this.loading = false;
      if (!this.enabled || !this.bookingId || this.disposed) return;
      this.loading = true;
      try {
        const act = await damageControlApi.getAct(this.axios, this.bookingId);
        if (active()) this.act = act;
      } catch (error) {
        if (active()) this.errorText = reportDamageControlFailure(this, error, { silent: true });
      } finally {
        if (active()) this.loading = false;
      }
    },
  },
};
